import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=8dd8cc7e&scoped=true"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"
import style0 from "./categoryList.vue?vue&type=style&index=0&id=8dd8cc7e&prod&lang=scss"
import style1 from "./categoryList.vue?vue&type=style&index=1&id=8dd8cc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd8cc7e",
  null
  
)

export default component.exports